import { MutationTree } from "vuex";

export const mutations: MutationTree<any> = {
	setInsight(state, payload) {
		state[payload.name] = payload.data;
	},
};
